document.addEventListener("DOMContentLoaded", function () {

  // 🛑 STOP if this is not the registration page
  if (!document.querySelector(".reg")) return;

  const base = 85;
  const inputs = document.querySelectorAll(".reg-bracket-input");
  const totalEl = document.getElementById("regTotal");
  const summary = document.getElementById("regBracketSummary");
  const submit = document.querySelector(".reg__submit");
  const gender = document.getElementById("playerGender");
  const refund = document.getElementById("refundCheck");
  const waiver = document.getElementById("waiverCheck");

  function update() {

    let total = base;
    let selected = [];
    let usedDays = [];

    // Enable everything first
    inputs.forEach(i => i.disabled = false);

    // Track used days
    inputs.forEach(i => {
      if (i.checked) usedDays.push(i.dataset.day);
    });

    // Disable same-day + gender restrictions
    inputs.forEach(i => {
      if (!i.checked && usedDays.includes(i.dataset.day)) {
        i.disabled = true;
      }

      if (
        gender.value &&
        i.dataset.gender !== gender.value &&
        i.dataset.gender !== "Mixed"
      ) {
        i.disabled = true;
      }
    });

    // Calculate total
    inputs.forEach(i => {
      if (i.checked) {
        total += parseInt(i.dataset.fee);
        selected.push(i.value);
      }
    });

    // Update summary
    summary.innerHTML = "";
    selected.forEach(s => {
      summary.innerHTML += `
        <div class="reg__line">
          <span>${s}</span>
        </div>
      `;
    });

    // Update total display
    totalEl.innerText = "$" + total;

    // Enable submit only if valid
    submit.disabled = !(
      selected.length > 0 &&
      refund.checked &&
      waiver.checked
    );
  }

  // Toggle policy dropdowns
  document.querySelectorAll(".reg__toggle").forEach(btn => {
    btn.addEventListener("click", function () {
      const content = this.nextElementSibling;
      content.style.display =
        content.style.display === "block" ? "none" : "block";
    });
  });

  // Event listeners
  inputs.forEach(i => i.addEventListener("change", update));
  gender.addEventListener("change", update);
  refund.addEventListener("change", update);
  waiver.addEventListener("change", update);

  // Initial state
  update();

});